module.exports = __webpack_public_path__ + "media/icons/facebook@3x-8497524e.svg";